// import { useEffect, useRef, useState } from "react";
// import { Box, useToast } from "@chakra-ui/react";
// import BreadCrumbMaker from "../../../components/BreadCrumbMaker";
// import { postNewVehicleSegment } from "../../../actions/management.action";
// import Form from "./Form";
// import { useNavigate } from "react-router-dom";

// const AddVehicle = () => {
//   const formRef = useRef(null);
//   const toast = useToast();
//   const navigator = useNavigate();
//   const [formDataObj, setFormDataObj] = useState({
//     segmentName: "",
//     description: "",
//     images: [],
//     vehicleTypes: "",
//     passengerCapacity: 0,
//     luggageCapacity: 0,
//     fuelTypes: [],
//     amenities: [],
//     status: "",
//     availability: false,
//   });

//   const handleSubmit = async (
//     event,
//     localRentals,
//     outStationOneWay,
//     outStationRoundTrip,
//     airportTransfer,
//     premium,
//     discount,
//     surcharges
//   ) => {
//     try {
//       event.preventDefault();
//       const formData = new FormData();

//       Object.entries(formDataObj).forEach(([key, value]) => {
//         if (Array.isArray(value)) {
//           formData.append(key, JSON.stringify(value));
//         } else if (value instanceof File || value instanceof Blob) {
//           formData.append(key, value);
//         } else {
//           formData.append(key, value);
//         }
//       });

//       let pricing = {
//         outstationOneWay: outStationOneWay,
//         outstationRoundTrip: outStationRoundTrip,
//         airportTransfer: airportTransfer,
//         localRental: localRentals,
//       };

//       formData.append("pricingInfo", JSON.stringify(pricing));
//       formData.append("premiumInfo", JSON.stringify(premium));
//       formData.append("discountInfo", JSON.stringify(discount));
//       formData.append("surchargesInfo", JSON.stringify(surcharges));

//       let res = await postNewVehicleSegment(formData);
//       if (res?.success) {
//         toast({
//           title: "Success",
//           description: "New vehicle segment is added",
//           status: "success",
//           duration: 5000,
//           isClosable: true,
//         });
//         // localStorage.removeItem("VehicleSegmentFormDraft");
//         navigator("/management/vehicles");
//       }
//     } catch (error) {
//       console.error(error);
//       toast({
//         title: "Error",
//         description: "Something went wrong",
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   };

//   useEffect(() => {
//     const savedDraft = localStorage.getItem("VehicleSegmentFormDraft");
//     if (savedDraft) {
//       setFormDataObj(JSON.parse(savedDraft));
//     }
//   }, []);

//   useEffect(() => {
//     localStorage.setItem(
//       "VehicleSegmentFormDraft",
//       JSON.stringify(formDataObj)
//     );
//   }, [formDataObj]);

//   return (
//     <Box px={6} py={8}>
//       <BreadCrumbMaker
//         items={[
//           // { link: "/", title: "Dashboard" },
//           { link: "/management", title: "Operations Setup" },
//           { link: "/management/vehicles", title: "Vehicles" },
//           {
//             link: "/management/vehicles/create",
//             title: "Add Vehicle",
//             on: true,
//           },
//         ]}
//       />
//       <Form
//         data={formDataObj}
//         setData={setFormDataObj}
//         handleSubmit={handleSubmit}
//         formRef={formRef}
//       />
//     </Box>
//   );
// };

// export default AddVehicle;


// NEW CODE DEFINED ON 7 DEC 2025 
import { useEffect, useRef, useState } from "react";
import { Box, useToast } from "@chakra-ui/react";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";
import { postNewVehicleSegment } from "../../../actions/management.action";
import Form from "./Form";
import { useNavigate } from "react-router-dom";

const AddVehicle = () => {
  const formRef = useRef(null);
  const toast = useToast();
  const navigator = useNavigate();
  const [formDataObj, setFormDataObj] = useState({
    segmentName: "",
    description: "",
    carImage: null, // Changed from images: [] to match API
    vehicleTypes: "",
    passengerCapacity: 0,
    luggageCapacity: 0,
    fuelTypes: [],
    amenities: [],
    status: "",
    availability: false,
  });

  const handleSubmit = async (
    event,
    localRentals,
    outStationOneWay,
    outStationRoundTrip,
    airportTransfer,
    premium,
    discount,
    surcharges,
    inclusions,
    exclusions
  ) => {
    try {
      event.preventDefault();
      const formData = new FormData();

      // Add basic fields
      formData.append('segmentName', formDataObj.segmentName || '');
      formData.append('description', formDataObj.description || '');
      formData.append('vehicleTypes', formDataObj.vehicleTypes || '');
      formData.append('passengerCapacity', formDataObj.passengerCapacity || 0);
      formData.append('luggageCapacity', formDataObj.luggageCapacity || 0);
      formData.append('status', formDataObj.status || '');
      formData.append('availability', formDataObj.availability || false);
      
      // Handle car image
      if (formDataObj.carImage instanceof File || formDataObj.carImage instanceof Blob) {
        formData.append('carImage', formDataObj.carImage);
      }

      // Handle arrays - stringify them
      formData.append('fuelTypes', JSON.stringify(formDataObj.fuelTypes || []));
      // Send amenities as comma-separated string for backend to split
      formData.append('amenities', typeof formDataObj.amenities === 'string' ? formDataObj.amenities : (formDataObj.amenities || []).join(', '));

      // Prepare pricing info
      let pricing = {
        outstationOneWay: outStationOneWay,
        outstationRoundTrip: outStationRoundTrip,
        airportTransfer: airportTransfer,
        localRental: localRentals,
      };

      formData.append("pricingInfo", JSON.stringify(pricing));
      // formData.append("premiumInfo", JSON.stringify(premium));
      // formData.append("discountInfo", JSON.stringify(discount));
      // formData.append("surchargesInfo", JSON.stringify(surcharges));
      formData.append("inclusions", JSON.stringify(inclusions || []));
      formData.append("exclusions", JSON.stringify(exclusions || []));
      formData.append("termsAndConditions", JSON.stringify(formDataObj.termsAndConditions || []));

      // Debug: Log FormData contents
      // console.log("FormData contents:");
      // for (let pair of formData.entries()) {
      //   if (pair[1] instanceof File) {
      //     console.log(pair[0], "File:", pair[1].name, pair[1].type);
      //   } else {
      //     console.log(pair[0], pair[1]);
      //   }
      // }

      let res = await postNewVehicleSegment(formData);
      
      if (res?.success) {
        toast({
          title: "Success",
          description: "New vehicle segment is added",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        localStorage.removeItem("VehicleSegmentFormDraft");
        navigator("/management/vehicles");
      } else {
        // Handle API error response
        toast({
          title: "Error",
          description: res?.message || "Failed to add vehicle segment",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast({
        title: "Error",
        description: error.message || "Something went wrong",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    const savedDraft = localStorage.getItem("VehicleSegmentFormDraft");
    if (savedDraft) {
      try {
        const parsedDraft = JSON.parse(savedDraft);
        // Don't restore file objects from localStorage
        if (parsedDraft.carImage && typeof parsedDraft.carImage === 'string') {
          // If it's a URL string, keep it
          setFormDataObj(parsedDraft);
        } else {
          // If it's a file object reference, remove it
          setFormDataObj({
            ...parsedDraft,
            carImage: null
          });
        }
      } catch (e) {
        console.error("Error parsing saved draft:", e);
      }
    }
  }, []);

  useEffect(() => {
    // Save draft but exclude file objects
    const draftToSave = {
      ...formDataObj,
      carImage: formDataObj.carImage instanceof File ? null : formDataObj.carImage
    };
    localStorage.setItem(
      "VehicleSegmentFormDraft",
      JSON.stringify(draftToSave)
    );
  }, [formDataObj]);

  return (
    <Box px={6} py={8}>
      <BreadCrumbMaker
        items={[
          { link: "/management", title: "Operations Setup" },
          { link: "/management/vehicles", title: "Vehicles" },
          {
            link: "/management/vehicles/create",
            title: "Add Vehicle",
            on: true,
          },
        ]}
      />
      <Form
        data={formDataObj}
        setData={setFormDataObj}
        handleSubmit={handleSubmit}
        formRef={formRef}
        isEdit={false}
        onCancel={() => navigator("/management/vehicles")}
      />
    </Box>
  );
};

export default AddVehicle;